import * as React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';

import { Query } from '@apollo/client/react/components';
import DashboardLayoutWrapper from '@opendoor/bricks/deprecated/UNSAFE_layout/DashboardLayoutWrapper';

import FullPageHomeLoader from '../components/FullPageHomeLoader';
import {
  GET_PURCHASE_AGREEMENT_URL,
  IGetPurchaseAgreementUrl,
  IGetPurchaseAgreementUrlVariables,
} from '../graphql/queries/GetPurchaseAgreementUrl';
import { PrivateRouteProps } from './PrivateRoute';
import { ERROR_PAGE_ROUTE } from './routes';

type PurchaseAgreementPageProps = RouteComponentProps<{ referralUUID: string }>;

class PurchaseAgreementPage extends React.PureComponent<PurchaseAgreementPageProps> {
  public static isAuthorized: PrivateRouteProps['isAuthorized'] = (human) =>
    human.has_partnership_referral_dashboard;

  public render() {
    const { match } = this.props;
    return (
      <DashboardLayoutWrapper>
        <section>
          <Query<IGetPurchaseAgreementUrl, IGetPurchaseAgreementUrlVariables>
            query={GET_PURCHASE_AGREEMENT_URL}
            variables={{ referralUUID: match.params.referralUUID }}
          >
            {({ data, error, loading }) => {
              if (error) {
                return <Redirect to={ERROR_PAGE_ROUTE} />;
              }

              if (!loading) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                window.location.href = data!.purchaseAgreementUrl;
              }

              return <FullPageHomeLoader />;
            }}
          </Query>
        </section>
      </DashboardLayoutWrapper>
    );
  }
}

export default PurchaseAgreementPage;
